(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/utils.js');
"use strict";


const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const isMobile = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp || svs.core.detect.formfactor.mobile();
function getDefaultLocationName() {
  return isMobile ? CONSTANTS.LOCATION_NAME_MOBILE : CONSTANTS.LOCATION_NAME_DEFAULT;
}
setGlobal('svs.lyckoplatsen.components.shared_constants', {
  getDefaultLocationName
});

 })(window);